<template>
    <div>
        <div class="content-caption dashed">
            <span>资产信息</span>
        </div>
        <div class="simple-form flex col-2">
            <div class="form-group center">
                <div class="form-label">
                    <label>资产描述全称</label>
                </div>
                <div class="form-value">
                    <span :title="assetInfo.title || '无' ">{{assetInfo.title || '无'}}</span>
                </div>
            </div>
            <div class="form-group center">
                <div class="form-label">
                    <label>资产名称</label>
                </div>
                <div class="form-value">
                    <span :title="assetInfo.name || '无' ">{{assetInfo.name || '无'}}</span>
                </div>
            </div>
            <div class="form-group center">
                <div class="form-label">
                    <label>品牌</label>
                </div>
                <div class="form-value">
                    <span :title="assetInfo.brandName || '无' ">{{assetInfo.brandName || '无'}}</span>
                </div>
            </div>
            <div class="form-group center">
                <div class="form-label">
                    <label>型号</label>
                </div>
                <div class="form-value">
                    <span :title="assetInfo.model || '无' ">{{assetInfo.model || "无"}}</span>
                </div>
            </div>
            <div class="form-group center">
                <div class="form-label">
                    <label>规格</label>
                </div>
                <div class="form-value">
                    <span :title="assetInfo.fixedSpec || '无' ">{{assetInfo.fixedSpec || "无"}}</span>
                </div>
            </div>
            <div class="form-group center">
                <div class="form-label">
                    <label>资产编号</label>
                </div>
                <div class="form-value">
                    <span>{{assetInfo.innerCode || '无'}}</span>
                </div>
            </div>
            <div class="form-group center">
                <div class="form-label">
                    <label>资产属性</label>
                </div>
                <div class="form-value">
                    <span v-if="assetNatureMap[assetInfo.assetNature] != null">{{assetNatureMap[assetInfo.assetNature] || '无'}}</span>
                    <span v-else>无</span>
                </div>
            </div>
            <div class="form-group center">
                <div class="form-label">
                    <label>资产分类</label>
                </div>
                <div class="form-value">
                    <span>{{assetInfo.innerDevcCatName || "无"}}</span>
                </div>
            </div>
            <div class="form-group center">
                <div class="form-label">
                    <label>外部系统编号</label>
                </div>
                <div class="form-value">
                    <span :title="assetInfo.innerNo || '无' ">{{assetInfo.innerNo || '无'}}</span>
                </div>
            </div>
            <div class="form-group center">
                <div class="form-label">
                    <label>含税单价(元)</label>
                </div>
                <div class="form-value">
                    <span v-if="assetInfo.price != null">{{assetInfo.price.toFixed(2) || 0.00}}</span>
                    <span v-else>0.00</span>
                </div>
            </div>
            <div class="form-group center">
                <div class="form-label">
                    <label>未税单价(元)</label>
                </div>
                <div class="form-value">
                    <span v-if="assetInfo.ntxPrice != null">{{assetInfo.ntxPrice.toFixed(2) || 0.00}}</span>
                    <span v-else>0.00</span>
                </div>
            </div>
            <div class="form-group center">
                <div class="form-label">
                    <label>原值(元)</label>
                </div>
                <div class="form-value">
                    <span>{{assetInfo.orgWorth == null ? '无' : assetInfo.orgWorth.toFixed(2)}}</span>
                </div>
            </div>
            <div class="form-group center">
                <div class="form-label">
                    <label>净值(元)</label>
                </div>
                <div class="form-value">
                    <span class="font-red">{{assetInfo.netWorth == null ? '无' : assetInfo.netWorth.toFixed(2)}}</span>
                </div>
            </div>
            <div class="form-group center">
                <div class="form-label">
                    <label>累计折旧(元)</label>
                </div>
                <div class="form-value">
                    <span>{{assetInfo.aggtDeprWorth == null ? '无' : assetInfo.aggtDeprWorth.toFixed(2)}}</span>
                </div>
            </div>
            <div class="form-group center">
                <div class="form-label">
                    <label>数量</label>
                </div>
                <div class="form-value">
                    <span class="font-red">{{assetInfo.assetType == 0 ? assetInfo.theQuantity : assetInfo.existQuanity}}</span>
                </div>
            </div>
            <div class="form-group center">
                <div class="form-label">
                    <label>单位</label>
                </div>
                <div class="form-value ">
                    <span>{{assetInfo.theUnit}}</span>
                </div>
            </div>
        </div>
        <div class="content-caption dashed">
            <span>拆分信息</span>
        </div>
        <el-form :model="splitInfo" :rules="rules" ref="ruleForm" class="demo-ruleForm">
            <div class="simple-form flex col-2">
                <div class="form-group center">
                    <div class="form-label">
                        <label :class="assetInfo.assetType == 0 ? '' : 'required'">拆分数量</label>
                    </div>
                    <div class="form-value">
                        <el-form-item prop="quantity" :rules="{validator: checkQuantity, trigger: 'blur'}" v-if="assetInfo.assetType == 1">
                            <el-input class="width-1-5x" type="number" min="1" v-model="splitInfo.quantity"></el-input>
                        </el-form-item>
                        <span v-else>{{splitInfo.quantity}}</span>
                    </div>
                </div>
                <div class="form-group center">
                    <div class="form-label">
                        <label class="required">拆分原值(元)</label>
                    </div>
                    <div class="form-value">
                        <el-form-item prop="orgWorth" :rules="{validator: checkOrgWorth, trigger: 'blur'}">
                            <el-input class="width-1-5x" type="number" v-model="splitInfo.orgWorth" @change="orgWorthChange"></el-input>
                        </el-form-item>
                    </div>
                </div>
                <div class="form-group center">
                    <div class="form-label">
                        <label>拆分净值(元)</label>
                    </div>
                    <div class="form-value">
                        <span>{{splitInfo.netWorth}}</span>
                    </div>
                </div>
                <div class="form-group center">
                    <div class="form-label">
                        <label>拆分累计折旧(元)</label>
                    </div>
                    <div class="form-value">
                        <span>{{splitInfo.aggtDeprWorth}}</span>
                    </div>
                </div>
                <div class="form-group center">
                    <div class="form-label">
                        <label>拆分含税额(元)</label>
                    </div>
                    <div class="form-value">
                        <span>{{splitInfo.price}}</span>
                    </div>
                </div>
                <div class="form-group center">
                    <div class="form-label">
                        <label>拆分未税额(元)</label>
                    </div>
                    <div class="form-value">
                        <span>{{splitInfo.ntxPrice}}</span>
                    </div>
                </div>
                <div class="form-group center">
                    <div class="form-label">
                        <label>拆分其他费用(元)</label>
                    </div>
                    <div class="form-value">
                        <span>{{splitInfo.xtraPrice}}</span>
                    </div>
                </div>
            </div>
        </el-form>

    </div>
</template>

<script>
    import { Utils } from '../../app.base'
    import { Vue, MsgBox, Routes } from '../../app.vues'

    import shopDevcApi from '../../api/shopDevc'

    export default {
        name: 'swb-asset-split-info',
        desc: '资产拆分',
        props: {
            assetInfo: {
                type: Object,
                deafult: function () {
                    return {};
                }
            }
        },
        data: function () {
            return {
                splitInfo: {},
                assetNatureMap: getEnumMap('assetNature', 'value2text')
            }
        },
        created: function () {
            let assetInfo = this.assetInfo;
            if(Utils.isNoB(assetInfo) || Utils.isNoB(assetInfo.id) || assetInfo.id <= 0) {
                MsgBox.warning("资产信息有误！");
                return;
            }
            //
            let splitInfo = this.assetInfo || {};
            splitInfo.quantity = 1;
            this.splitInfo = Utils.merge({}, splitInfo);
        },
        methods: {
            checkQuantity: function (rule, value, callback) {
                if(Utils.isNoB(value)) {
                    callback(new Error('不可为空!'));
                } else {
                    if(Utils.isNaturalStr(value, true) && parseInt(value) > 0) {
                        callback();
                    } else {
                        callback(new Error('必须为大于0的整数!'));
                    }
                }
            },
            checkOrgWorth: function (rule, value, callback) {
                if(Utils.isNoB(value)) {
                    callback(new Error('不可为空!'));
                } else {
                    if(Utils.isMoneyStr(value) && parseFloat(value) > 0) {
                        let assetInfo = this.assetInfo || {};
                        let netWorth = assetInfo.netWorth || 0;
                        if(parseFloat(value) > parseFloat(netWorth)) {
                            callback(new Error('拆分净值超过了原有净值!'));
                        } else {
                            callback();
                        }
                    } else {
                        callback(new Error('必须为大于0的数字!'));
                    }
                }
            },
            // 净值变化事件
            orgWorthChange: function () {
                let self = this;
                let splitInfo = this.splitInfo;
                if(!Utils.isNoB(splitInfo.orgWorth) && Utils.isMoneyStr(splitInfo.orgWorth)) {
                    splitInfo.orgWorth = parseFloat(splitInfo.orgWorth).toFixed(2);
                    //
                    let assetInfo = this.assetInfo || {};
                    let orgWorth = assetInfo.orgWorth || 0;
                    if(parseFloat(orgWorth) <= 0) {
                        MsgBox.warning("被拆分的资产已无原值不能再拆分！");
                        return;
                    }
                    if(parseFloat(splitInfo.orgWorth) > parseFloat(orgWorth)) {
                        MsgBox.warning("拆分原值超过了原有原值，请重新输入拆分原值！");
                        return;
                    }
                    //
                    let orgWorthInit = assetInfo.orgWorthInit || 0;
                    let netWorth = assetInfo.netWorth || 0;
                    let aggtDeprWorth = assetInfo.aggtDeprWorth || 0;
                    let price = assetInfo.price || 0;
                    let ntxPrice = assetInfo.ntxPrice || 0;
                    let xtraPrice = assetInfo.xtraPrice || 0;
                    //
                    let postData = {};
                    postData.srcOrgWorthInit = orgWorthInit;
                    postData.srcOrgWorth = orgWorth;
                    postData.srcAggtDeprWorth = aggtDeprWorth;
                    postData.srcPrice = price;
                    postData.srcNtxPrice = ntxPrice;
                    postData.srcXtraPrice = xtraPrice;
                    postData.srcNetWorth = netWorth;
                    postData.dstOrgWorth = splitInfo.orgWorth;
                    let theLoad = MsgBox.loading();
                    shopDevcApi.getCalAssetWorth(postData, function (result) {
                        theLoad.hide();
                        if(result.type === "info") {
                            let worthInfo = result.data || {};
                            //
                            splitInfo.netWorth = parseFloat(worthInfo.dstNetWorth).toFixed(2);
                            splitInfo.orgWorthInit = parseFloat(worthInfo.dstOrgWorthInit).toFixed(2);
                            // splitInfo.orgWorth = parseFloat(worthInfo.dstOrgWorth).toFixed(2);
                            splitInfo.aggtDeprWorth = parseFloat(worthInfo.dstAggtDeprWorth).toFixed(2);
                            splitInfo.price = parseFloat(worthInfo.dstPrice).toFixed(2);
                            splitInfo.ntxPrice = parseFloat(worthInfo.dstNtxPrice).toFixed(2);
                            splitInfo.xtraPrice = parseFloat(worthInfo.dstXtraPrice).toFixed(2);
                            self.splitInfo = Utils.merge({}, splitInfo);
                        } else {
                            MsgBox.warning(result.message);
                        }
                    });
                } else {
                    splitInfo.orgWorthInit = null;
                    splitInfo.netWorth = null;
                    splitInfo.aggtDeprWorth = null;
                    splitInfo.price = null;
                    splitInfo.ntxPrice = null;
                    splitInfo.xtraPrice = null;
                    this.splitInfo = Utils.merge({}, splitInfo);
                }
            },
            //
            getDlgResult(){
                let self = this;
                let result = {};
                this.$refs['ruleForm'].validate(function (valid) {
                    let splitInfo = self.splitInfo || {};
                    if(valid) {
                        splitInfo.id = self.assetInfo.id;
                        splitInfo.assetType = self.assetInfo.assetType;
                        //
                        result.type = "info";
                        result.data = splitInfo;
                    } else {
                        result.type = "wran";
                        if(parseFloat(splitInfo.netWorth) > parseFloat(self.assetInfo.netWorth)) {
                            result.message = '拆分净值超过了原有净值，请重新输入拆分净值！';
                        } else {
                            result.message = '请输入拆分信息！';
                        }
                    }
                });
                return result;
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/compo/retailer/AssetSplitInfo.vue